// extracted by mini-css-extract-plugin
module.exports = {"content":"fa","container":"fb","title":"fc","text":"fd","textForm":"fe","submitButton":"ff"};